// extracted by mini-css-extract-plugin
export default {"tileContainer":"tile_tileContainer__yiBG6","tile":"tile_tile__i4YnB","secondary":"tile_secondary__XmdZU"};